import React from 'react';
import SignUp from './authantication/Signup';
import LogIn from './authantication/Login';
import TeamInfo from '../modal/TeamInfo';
;
const Modals = () => {
  return (
    <>
      <SignUp />
      <LogIn />
      <TeamInfo />
    </>
  )
}

export default Modals;
